import { MySurveysPageIndexDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { MySurveysDatatable } from 'modules/trainings/components/MyTrainings/MySurveys'

const Surveys = () => {
  const { data, loading, error } = useQuery(MySurveysPageIndexDocument)

  return (
    <ResponsivePage.Body loading={loading} error={error} variant="full">
      <MySurveysDatatable trainings={data?.trainings.trainingsConnection.nodes ?? []} />
    </ResponsivePage.Body>
  )
}
export default Surveys
